
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
}

export const SEO = ({ title, description }: SEOProps) => {
  const siteTitle = "Bright Stages";
  const fullTitle = `${title} | ${siteTitle}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="icon" href="/lovable-uploads/69ea552b-2955-4bc9-a6bb-8cb9ed409860.png" />
      <link rel="shortcut icon" href="/lovable-uploads/69ea552b-2955-4bc9-a6bb-8cb9ed409860.png" />
      <link rel="apple-touch-icon" href="/lovable-uploads/69ea552b-2955-4bc9-a6bb-8cb9ed409860.png" />
    </Helmet>
  );
};
